import React from 'react';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

const DROPDOWN_CLASS = 'app-range-picker-dropdown';

function mergeClassNames(...values) {
  return values.filter(Boolean).join(' ');
}

const AppRangePicker = React.forwardRef(function AppRangePicker(
  {
    getPopupContainer = () => document.body,
    popupClassName,
    classNames,
    ...rest
  },
  ref,
) {
  const mergedPopupClassName = mergeClassNames(DROPDOWN_CLASS, popupClassName, classNames?.popup?.root);

  const mergedClassNames = classNames
    ? {
        ...classNames,
        popup: {
          ...classNames.popup,
          root: mergedPopupClassName,
        },
      }
    : undefined;

  return (
    <RangePicker
      ref={ref}
      getPopupContainer={getPopupContainer}
      popupClassName={mergedPopupClassName}
      classNames={mergedClassNames}
      {...rest}
    />
  );
});

AppRangePicker.displayName = 'AppRangePicker';

export default AppRangePicker;
